import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { PayrollTransactionListColumns } from "../../appconfig/DatatableSetting";
import { getAllDetails, postSingleData } from "../../service/ProductService";
import { GET_REPORT_SUMMARY_LIST, POST_PAYROLL_TRANSACTION, T4_SUMMARY } from "../../config/ApiConstant";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { useParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";

const PayrollTransactionDetails = () => {
  document.title = "Payroll Transaction Details | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);

  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [payrollTransactionSummaryDialog, setPayrollTransactionSummaryDialog] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // filters
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.roles?.role_name || "";

  // get client id from param
  const { id }: any = useParams();
  const clientId = id ? atob(id) : null;

  // useefect for get payroll transaction list
  useEffect(() => {
    getPayrollTransactionList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedYear]);

  // list-employee
  const getPayrollTransactionList = async () => {
    try {
      // select id based on user role
      let idToSend = null;
      let emp_id = null;
      if (userRole === "Client") {
        idToSend = userData?.id;
      } else if (userRole === "Employee") {
        emp_id = userData?.id;
      } else {
        idToSend = clientId;
      }

      const response = await getAllDetails(`${GET_REPORT_SUMMARY_LIST}/${idToSend}?type=payroll_transaction&year=${selectedYear}`);

      const data = response;
      if (data) {
        setEmployeeList(data || []);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // payroll transaction dialog
  const payrollTransactionDialog = async () => {
    setPayrollTransactionSummaryDialog(true);
  };

  // submit T4 dialog
  const submitPayrollTransaction = async () => {
    setSubmitLoading(true);
    try {
      // select id based on user role
      let clientIdToUse = null;
      if (userRole === "User") {
        clientIdToUse = clientId;
      } else if (userRole === "Client") {
        clientIdToUse = userData?.id;
      }

      const response = await postSingleData(`${POST_PAYROLL_TRANSACTION}/${clientIdToUse}`);

      if (response) {
        if (!window.cn(response?.data)) {
          const summary_pdf = response?.data;
          setTimeout(() => {
            window.open(summary_pdf, "_blank");
          }, 1000);
        }
        setPageLoad(true);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hidePayrollTransactionDialog();
        getPayrollTransactionList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // hide payroll transaction modal
  const hidePayrollTransactionDialog = () => {
    setPayrollTransactionSummaryDialog(false);
    setSubmitLoading(false);
  };

  // clear all filter
  const clearAll = () => {
    setSelectedYear(currentYear);
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      {/* <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
      </span> */}
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <div className="payrollreport-template">
      {userRole !== "Employee" && (
        <>
          {/* <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="mr-3 p-button-outlined common-p-outline-button" /> */}

          <Calendar
            id="year"
            value={moment(selectedYear, "YYYY").toDate()}
            onChange={(e) => {
              const selectedDate = e.value;
              if (selectedDate instanceof Date) {
                const year = moment(selectedDate).year();
                setSelectedYear(year);
              }
            }}
            view="year"
            dateFormat="yy"
            showIcon
            placeholder="Filter by year"
            className="mr-2 w-15rem"
          />

          <Button
            className="ml-1 common-primary-button mr-3"
            icon="pi pi-plus"
            label="Gen Payroll Transaction"
            onClick={() => payrollTransactionDialog()}
          />
        </>
      )}
    </div>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.url) {
      window.open(rowData?.url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  return (
    <>
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                responsiveLayout={"scroll"}
                dataKey="id"
                stripedRows
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Payroll Transaction"}
                emptyMessage="No Payroll Transaction Details Found"
                removableSort
              >
                {PayrollTransactionListColumns.map((col, i) => {
                  if (col.field === "url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {PayrollTransactionListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Generate t4 dialog */}
      <Dialog
        visible={payrollTransactionSummaryDialog}
        style={{ width: "600px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Generate Payroll Transaction Summary"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="mr-2 p-button-secondary"
              onClick={hidePayrollTransactionDialog}
              disabled={submitLoading}
            />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={submitPayrollTransaction} loading={submitLoading} />
          </div>
        }
        onHide={hidePayrollTransactionDialog}
      >
        <h4 className="mb-4">Do you want to generate Payroll Transaction Summary ? </h4>
      </Dialog>
    </>
  );
};
export default PayrollTransactionDetails;
